import { render, staticRenderFns } from "./Handles.vue?vue&type=template&id=5ecec348&scoped=true&"
import script from "./Handles.vue?vue&type=script&lang=js&"
export * from "./Handles.vue?vue&type=script&lang=js&"
import style0 from "./Handles.vue?vue&type=style&index=0&id=5ecec348&lang=scss&scoped=true&"
import style1 from "./Handles.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecec348",
  null
  
)

export default component.exports